export default __webpack_public_path__ + "static/media/Trifold-Brochure-Mock-Up.da2fe703.png";